import {configs} from '../resources/configs';
import {getAccessToken, logoutApp} from './AuthUtill';
import {FilesStorageType} from '../models/Common';
import {encode as encodeWebp} from '@jsquash/webp';


export const prepareFileToUpload = (file, action, actionUrl, setIsLoading, tempName, isUploadToS3 = true, compressToBytesSize = 4057152, isCompress = true) => {
  if (file) {
    setIsLoading(true);
    console.log('File size ' + file.size);

    uploadFileToS3Post(file, tempName, (pathTemp) => {
      action(pathTemp);
      setIsLoading(false);
      actionUrl(URL.createObjectURL(file));
    });
  }
};

export const uploadFileToS3Post = (file, fileName, bucketType = 'RES_REELS', path = '', callback) => {
  const execute = (storageType, callback) => {
    const xhr = new XMLHttpRequest();
    xhr.open('POST', configs.apiUrl + '/presigned-data/create', true);
    xhr.setRequestHeader('content-type', 'application/json;charset=UTF-8');
    xhr.setRequestHeader('authorization', getAccessToken());

    const onload = (responseText) => {
      const presignedPostData = JSON.parse(responseText);
      const formData = new FormData();
      Object.keys(presignedPostData.fields).forEach((key) => {
        formData.append(key, presignedPostData.fields[key]);
      });

      formData.append('file', file);
      const xhr = new XMLHttpRequest();
      xhr.open('POST', presignedPostData.url, true);
      xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.send(formData);
      xhr.onload = function(e) {
        if (xhr.status >= 200 && xhr.status < 400) {
          callback(presignedPostData.fields.key);
        }
      };
    };

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          onload(xhr.responseText);
        } else if (xhr.status === 401) {
          logoutApp();
        }
      }
    };

    xhr.send(JSON.stringify({bucketType, path, name: fileName, storageType}));
  }

  execute(FilesStorageType.DIGITAL_OCEAN, () => execute(FilesStorageType.AWS, callback))
};

export const uploadFileToS3Put = (file, fileName, bucketType = 'ONELIGHT_PUBLIC', path = '', contentType = 'application/json', callback) => {
  const xhr = new XMLHttpRequest();
  xhr.open('POST', configs.apiUrl + '/presigned-data/create', true);
  xhr.setRequestHeader('content-type', 'application/json');
  xhr.setRequestHeader('authorization', getAccessToken());
  const onload = (responseText) => {
    const presignedPostData = JSON.parse(responseText);
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', presignedPostData.url, true);
    if (!configs.isLocal) {
      xhr.withCredentials = true;
    }
    xhr.setRequestHeader('content-type', contentType);
    xhr.send(file);
    xhr.onload = function(e) {
      if (xhr.status >= 200 && xhr.status < 400) {
        callback();
      }
    };
  };

  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200) {
        onload(xhr.responseText);
      } else if (xhr.status === 401) {
        logoutApp();
      }
    }
  };

  xhr.send(JSON.stringify({bucketType, path, name: fileName, isPutMethod: true}));
};

export const getFilenameFromUrl = (url) => {
  if (url) {
    const m = url.toString().match(/.*\/(.+?)\./);
    if (m && m.length > 1) {
      return m[1] + '.' + url.replace(m[0], '');
    }
  }
  return '';
};

export const getFilenameWithoutType = (filename) => {
  if (filename) {
    const type = filename.split('.').pop();
    if (!type) {
      return filename;
    }

    return filename.replace('.' + type, '');
  }
  return '';
};

export const ab2str = (buf) => {
  return String.fromCharCode.apply(null, new Uint8Array(buf));
};

/**
 * Конвертирует <canvas> в WebP-Blob с гарантированной поддержкой Safari.
 *  1. Пробуем нативный canvas.toBlob (Chrome / Firefox / Edge).
 *  2. Safari молча игнорирует 'image/webp' и отдаёт PNG, поэтому проверяем
 *     РЕАЛЬНЫЙ blob.type, а не то, что запрашивали.
 *  3. Если WebP не получился — кодируем сами через WASM-энкодер libwebp (@jsquash/webp).
 */
export const canvasToWebP = async (canvas, quality = 0.85) => {
  const nativeBlob = await new Promise((resolve) =>
    canvas.toBlob(resolve, 'image/webp', quality)
  );
  if (nativeBlob && nativeBlob.type === 'image/webp') {
    return nativeBlob;
  }
  // Фолбэк для Safari: canvas в webp не умеет — кодируем через WASM (работает в любом браузере).
  const ctx = canvas.getContext('2d');
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const webpBuffer = await encodeWebp(imageData, {quality: Math.round(quality * 100)});
  return new Blob([webpBuffer], {type: 'image/webp'});
};

export const convertToWebp = (file, quality = 0.85) => new Promise((resolve, reject) => {
  const img = new Image();
  const url = URL.createObjectURL(file);
  const baseName = file.name.replace(/\.[^.]+$/, '');
  img.onload = async () => {
    try {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext('2d').drawImage(img, 0, 0);
      URL.revokeObjectURL(url);
      const blob = await canvasToWebP(canvas, quality);
      resolve(new File([blob], `${baseName}.webp`, {type: 'image/webp'}));
    } catch (e) {
      reject(e);
    }
  };
  img.onerror = () => {
    URL.revokeObjectURL(url);
    reject(new Error('Image load failed'));
  };
  img.src = url;
});

export const webpIsSupported = (blob, callback) => {
  if (!window.createImageBitmap) {
    callback(false, blob);
    return;
  }

  createImageBitmap(blob).then(() => {
    callback(true, blob);
  }, (err) => {
    console.log(err);
    callback(false, blob);
  });
};


(function createImageBitmapIIFE(global) {
  function isCanvasImageSource(el) {
    const validElements = [
      'img',
      'video',
      'canvas',
    ];

    return (el && el.tagName && validElements.includes(el.tagName.toLowerCase()));
  }

  function idealSize(currentValue, newValue, numerator, denominator) {
    if (typeof newValue === 'number') return newValue;
    if (typeof numerator !== 'number' || typeof denominator !== 'number') return currentValue;

    return (numerator / denominator) * currentValue;
  }

  if (!('createImageBitmap' in global)) {
    global.createImageBitmap = async function polyfillCreateImageBitmap(data, opts) {
      return new Promise((resolve, reject) => {
        opts = opts || {};

        let dataURL;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        if (data instanceof Blob) {
          dataURL = URL.createObjectURL(data);
        } else if (isCanvasImageSource(data)) {
          const width = data.naturalWidth || data.videoWidth || data.clientWidth || data.width;
          const height = data.naturalHeight || data.videoHeight || data.clientHeight || data.height;
          canvas.width = idealSize(width, opts.resizeWidth, opts.resizeHeight, height);
          canvas.height = idealSize(height, opts.resizeHeight, opts.resizeWidth, width);

          ctx.drawImage(data, 0, 0, canvas.width, canvas.height);

          dataURL = canvas.toDataURL();
        } else if (data instanceof ImageData) {
          canvas.width = idealSize(data.width, opts.resizeWidth, opts.resizeHeight, data.height); ;
          canvas.height = idealSize(data.height, opts.resizeHeight, opts.resizeWidth, data.width);

          ctx.putImageData(data, 0, 0);

          dataURL = canvas.toDataURL();
        } else {
          throw new Error('createImageBitmap does not handle the provided image source type');
        }

        const img = new Image();
        img.onload = () => resolve(img);
        img.src = dataURL;
      });
    };
  }
})(window);

export const saveFile = (fileUrl) => {
  const xhr = new XMLHttpRequest();
  xhr.open('GET', fileUrl, true);
  if (!configs.isLocal) {
    xhr.withCredentials = true;
  }
  xhr.responseType = 'blob';
  xhr.onreadystatechange = () => {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      if (xhr.status === 200) {
        saveAs(window.URL.createObjectURL(xhr.response), getFilenameFromUrl(fileUrl));
      }
    }
  };

  xhr.send();
};

export const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.split(',')[1]);

  reader.onerror = (error) => reject(error);
});

export const parseJsonFile = (file) => new Promise((resolve, reject) => {
  const fileReader = new FileReader();
  fileReader.onload = (event) => resolve(JSON.parse(event.target.result));
  fileReader.onerror = (error) => reject(error);
  fileReader.readAsText(file);
});

export const parseStringFile = (file) => new Promise((resolve, reject) => {
  const fileReader = new FileReader();
  fileReader.onload = (event) => resolve(event.target.result);
  fileReader.onerror = (error) => reject(error);
  fileReader.readAsText(file);
});


export const getFileNameExt = (fileName) => {
  return fileName.split('.').pop();
}

// Capture times tried in order, seconds. A seek to 0 on a freshly loaded video is a no-op: "seeked" fires
// before the frame is decoded and drawImage paints an empty (black) canvas, mostly in Safari.
const FRAME_CAPTURE_TIMES = [0.1, 0.5, 1, 2];
// Mean RGB below this on every channel counts as an empty frame.
const BLACK_FRAME_MAX_MEAN = 3;

const waitForEvent = (target, event, timeoutMs) => new Promise((resolve, reject) => {
  const timer = setTimeout(() => {
    target.removeEventListener(event, onEvent);
    reject(new Error(`Timeout waiting for video "${event}"`));
  }, timeoutMs);
  function onEvent() {
    clearTimeout(timer);
    target.removeEventListener(event, onEvent);
    resolve();
  }
  target.addEventListener(event, onEvent);
});

// Resolves once the frame at the current position has actually been presented.
const waitForFramePresented = (video) => new Promise((resolve) => {
  if (typeof video.requestVideoFrameCallback === 'function') {
    let done = false;
    const finish = () => { if (!done) { done = true; resolve(); } };
    video.requestVideoFrameCallback(finish);
    // Paused videos may not present a new frame after a seek in some browsers
    setTimeout(finish, 500);
  } else {
    requestAnimationFrame(() => requestAnimationFrame(resolve));
  }
});

const isBlackFrame = (ctx, width, height) => {
  const step = Math.max(1, Math.floor(Math.min(width, height) / 50));
  const {data} = ctx.getImageData(0, 0, width, height);
  let r = 0; let g = 0; let b = 0; let n = 0;
  for (let y = 0; y < height; y += step) {
    for (let x = 0; x < width; x += step) {
      const i = (y * width + x) * 4;
      r += data[i]; g += data[i + 1]; b += data[i + 2]; n++;
    }
  }
  return n > 0 && r / n < BLACK_FRAME_MAX_MEAN && g / n < BLACK_FRAME_MAX_MEAN && b / n < BLACK_FRAME_MAX_MEAN;
};

const canvasToJpeg = (canvas) => new Promise((resolve, reject) => {
  canvas.toBlob((blob) => {
    if (blob) {
      resolve(new File([blob], 'frame.jpg', {type: 'image/jpeg'}));
    } else {
      reject(new Error('Failed to convert canvas to blob'));
    }
  }, 'image/jpeg', 0.92);
});

// Preview image for a video: the first non-black frame near the start. Rejects instead of returning
// an empty frame, so the caller never uploads a black preview.
export async function getFirstFrameAsImage(videoFile) {
  const video = document.createElement('video');
  const url = URL.createObjectURL(videoFile);
  video.preload = 'auto';
  video.muted = true;
  video.playsInline = true;
  // Off-screen but attached: Safari does not decode frames of a detached, never-played video
  video.style.cssText = 'position:fixed;left:-10000px;top:0;width:1px;height:1px;opacity:0;pointer-events:none';
  document.body.appendChild(video);
  try {
    const loaded = waitForEvent(video, 'loadeddata', 30000);
    const failed = waitForEvent(video, 'error', 30000).then(() => { throw new Error('Error loading video'); });
    video.src = url;
    await Promise.race([loaded, failed]);

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d', {willReadFrequently: true});
    const duration = Number.isFinite(video.duration) ? video.duration : 0;
    const times = FRAME_CAPTURE_TIMES.filter((t) => !duration || t < duration);
    if (times.length === 0) {
      times.push(duration / 2);
    }

    for (const time of times) {
      const seeked = waitForEvent(video, 'seeked', 10000);
      video.currentTime = time;
      await seeked;
      await waitForFramePresented(video);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      if (!isBlackFrame(ctx, canvas.width, canvas.height)) {
        return await canvasToJpeg(canvas);
      }
    }
    throw new Error('Could not capture a non-black preview frame');
  } finally {
    video.removeAttribute('src');
    video.load();
    video.remove();
    URL.revokeObjectURL(url);
  }
}
